import { makeStyles } from '@material-ui/core/styles';
import AudioVideoWrapper from 'components/AudioVideoWrapper';
import ErrorPage from 'components/ErrorPage';
import GridView from 'components/GridView';
import VideoTile from 'components/VideoTile';
import LoadingSpinner from 'components/LoadingSpinner';
import MeetingStatus from 'enums/MeetingStatus';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { recordChimeMeetingAction } from 'store/classroom/classroomActions';

const useStyles = makeStyles(() => ({
  root: {},
}));

export default function Recording(props) {
  const { meetingStatus, errorMessage, contentTile } = useSelector(
    ({ chime, classroom, video }) => ({
      meetingStatus: chime.meetingStatus,
      contentTile: video.contentTile,
      errorMessage: classroom.actionStatus.joinMeeting?.error,
    })
  );
  const classes = useStyles(props);
  const audioElement = useRef(null);
  const query = new URLSearchParams(useLocation().search);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(recordChimeMeetingAction({ audioElement: audioElement, token: query.get('token') }));
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes.root}>
      <audio ref={audioElement} style={{ display: 'none' }} />
      {meetingStatus === MeetingStatus.Loading && <LoadingSpinner />}
      {meetingStatus === MeetingStatus.Failed && <ErrorPage errorMessage={errorMessage} />}
      {meetingStatus === MeetingStatus.Succeeded && (
        <AudioVideoWrapper>
          <div style={{ height: '100vh' }}>
            <GridView isRecordingUser={true}>
              {contentTile?.id && (
                <VideoTile
                  videoTileId={contentTile.tileId}
                  thisAttendeeId={contentTile.id}
                  isContent={true}
                  height={'100%'}
                />
              )}
            </GridView>
          </div>
        </AudioVideoWrapper>
      )}
    </div>
  );
}
